import IpubSelectOption from '../select/src/option'

/* istanbul ignore next */
IpubSelectOption.install = function(Vue) {
  Vue.component(IpubSelectOption.name, IpubSelectOption)
}

export default IpubSelectOption
